module.exports = __webpack_public_path__ + "static/media/All Projects.759c9e28.759c9e28.svg";